import {UserDto} from '../../scaffold';

export default function UserKeywordFilter(user: UserDto, keyword: string) {
  return ((user.name || '') + user?.username).includes(keyword);
}
